<template>
    <div>
        <Navbar />
        <BuyNow />
        <PageTitle pageTitle="Kurslarımız" />
        <Courses pathUrl="https://dryyazilim.com.tr/anaokulu/assets/data/get.php" />
        <Footer />
    </div>
</template>

<script>
import Navbar from '../Layouts/Navbar'
import PageTitle from '../Common/PageTitle'
import Courses from '../Courses/CoursesList'
import Footer from '../Layouts/Footer'
import BuyNow from '../Layouts/BuyNow'

export default {
    name: 'CoursesPageThree',
    components: {
    Navbar,
    PageTitle,
    Courses,
    Footer,
    BuyNow
},
}
</script>